import MyPageContainer from './MyPageContainer';
export default MyPageContainer;
